import { CustomDialog } from "@/components/ui-elements";
import { useFolderData } from "@/components/ui-elements/SideMenu/hooks/useFolderData";
import TextField from "@mui/material/TextField";
import type { ForwardRefRenderFunction } from "react";
import { forwardRef, useState } from "react";
// import { useNavigate } from "react-router-dom";

interface AddFolderPopupProps {
  onClose: () => void;
}

const AddFolderPopupComponent: ForwardRefRenderFunction<
  HTMLDivElement,
  AddFolderPopupProps
> = ({ onClose }) => {
  const { createFolder } = useFolderData();
  const [folderName, setFolderName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const navigation = useNavigate();

  const handleNext = async () => {
    if (isSubmitting) return;

    try {
      setIsSubmitting(true);
      await createFolder(folderName);
      if (onClose) {
        onClose();
      }
    } catch (error) {
      // Error handling
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CustomDialog
      title="フォルダを追加"
      description="フォルダを追加します。フォルダ名を登録してください。"
      open={true}
      onClose={onClose}
      primaryButtonText="登録する"
      primaryButtonAction={handleNext}
      primaryButtonDisabled={folderName.trim() === "" || isSubmitting}
      secondaryButtonText="キャンセル"
      secondaryButtonAction={onClose}
    >
      <TextField
        autoFocus
        margin="dense"
        id="name"
        placeholder="請求書フォルダ"
        type="text"
        fullWidth
        value={folderName}
        onChange={(e) => setFolderName(e.target.value)}
        label="フォルダ名"
        disabled={isSubmitting}
        onKeyDown={(e) => {
          if (
            e.key === "Enter" &&
            !e.nativeEvent.isComposing &&
            folderName.trim() !== ""
          ) {
            handleNext();
          }
        }}
      />
    </CustomDialog>
  );
};

const AddFolderPopup = forwardRef(AddFolderPopupComponent);
AddFolderPopup.displayName = "AddFolderPopup";

export default AddFolderPopup;
